module.exports = __webpack_public_path__ + "static/img/cha-lr-1.3fa4f8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cha/cha-lr-1.png
// module id = yoOO
// module chunks = 1